import React from 'react';
import './index.scss';

export default function Button({
  type = 'default', // 'primary' | 'danger' | 'info' | 'warning' | 'default'
  size = 'default', // 'large' | 'default' | 'small'
  disabled = false,
  className = '',
  children,
  onClick,
  ...rest
}) {
  let btnClass = 'c-btn';
  if (type === 'primary') btnClass += ' c-btn-primary';
  if (type === 'danger') btnClass += ' c-btn-danger';
  if (type === 'info') btnClass += ' c-btn-info';
  if (type === 'warning') btnClass += ' c-btn-warning';
  if (size === 'large') btnClass += ' c-btn-large';
  if (size === 'small') btnClass += ' c-btn-small';
  if (disabled) btnClass += ' c-btn-disabled';
  if (className) btnClass += ' ' + className;

  return (
    <button
      className={btnClass}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      {children}
    </button>
  );
} 